import { useEffect } from 'react';
import { techdocsPlugin } from '@backstage/plugin-techdocs';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
  useShadowRootElements,
} from '@backstage/plugin-techdocs-react';
import { useFeedbackContext } from '@internal/plugin-user-feedback';

const TechDocsFeedbackAddon = () => {
  const anchors = useShadowRootElements<HTMLAnchorElement>(['a']);
  const { openFeedback } = useFeedbackContext();

  useEffect(() => {
    anchors.forEach(a => {
      const url = new URL(a.href);
      if (url.searchParams.get('feedback') === 'open') {
        a.href = '#';
        a.addEventListener('click', e => {
          e.preventDefault();
          openFeedback();
        });
      }
    });

    return () => {
      anchors.forEach(a => {
        a.removeEventListener('click', () => {});
      });
    };
  }, [anchors, openFeedback]);

  return null;
};

export const TechDocsFeedback = techdocsPlugin.provide(
  createTechDocsAddonExtension({
    name: 'TechDocsFeedback',
    location: TechDocsAddonLocations.Content,
    component: TechDocsFeedbackAddon,
  }),
);
